import { useNavigate } from "react-router-dom";
import Description from "../../../components/ui/Description";
import TitleStyles from "../../../components/ui/TitleStyles";
import ProgressBar from "../../../components/progressBar/ProgressBar";
import InputLinkGroup from "../../../components/inputLinkGroup/InputLinkGroup";
import ButtonGroup from "../../../components/ui/ButtonGroup";
import { Container, Position } from "./EventsyStyles";
import TooltipModal from "../../../components/tooltipModal/TooltipModal";
import { useState } from "react";

const Events = () => {
  const navigate = useNavigate();
  const [showTooltip, setShowTooltip] = useState(true);

  return (
    <Container>
      {showTooltip && (
        <TooltipModal
          onClose={() => setShowTooltip(false)}
          buttonLabel="Entendi"
        >
          <p>
            <strong>Adicione Links aos Seus Eventos!</strong>
            <br />
            Ao preencher seus eventos, você pode incluir um link opcional para
            mais detalhes, como ingressos, páginas oficiais ou informações
            adicionais.
          </p>
        </TooltipModal>
      )}
      <TitleStyles>Evento</TitleStyles>
      <Description>Eventos antigos ou próximos eventos</Description>

      <InputLinkGroup
        nameLabel="Nome"
        namePlaceholder="Nome do evento"
        urlLabel="Link"
        urlPlaceholder="https://www.link.com"
        onChange={(items) => console.log("Evento:", items)}
        previewEnabled={false}
        urlRequired={false}
      />

      <Position>
        <ProgressBar totalSteps={9} currentStep={2} />
        <ButtonGroup
          onBack={() => navigate("/music-sets")}
          onNext={() => navigate("/video")}
        />
      </Position>
    </Container>
  );
};

export default Events;
